import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { default as Segmented } from 'antd/es/segmented';

import type { AuthMethod } from './constants';
import {
  CREATE_KEY_METHOD_INFO_JWT,
  CREATE_KEY_METHOD_INFO_PKCS,
  CREATE_KEY_METHOD_INFO_PKCS_NO_ENCRYPTION,
  CREATE_KEY_METHOD_INFO_TEST_ID,
  CREATE_KEY_METHOD_JWT_LABEL,
  CREATE_KEY_METHOD_OPTION_TEST_ID,
  CREATE_KEY_METHOD_PKCS_LABEL
} from './constants';

type AuthMethodSegmentedProps = {
  value: AuthMethod;
  onChange: (method: AuthMethod) => void;
  requiresUpload: boolean;
};

const infoMessage = (value: AuthMethod, requiresUpload: boolean): string => {
  if (value === 'jwt') {
    return CREATE_KEY_METHOD_INFO_JWT;
  }
  return requiresUpload
    ? CREATE_KEY_METHOD_INFO_PKCS
    : CREATE_KEY_METHOD_INFO_PKCS_NO_ENCRYPTION;
};

export const AuthMethodSegmented = ({
  value,
  onChange,
  requiresUpload
}: AuthMethodSegmentedProps) => (
  <div className="flex flex-col gap-3">
    <Segmented
      block
      value={value}
      onChange={(next) => onChange(next as AuthMethod)}
      options={[
        {
          value: 'pkcs',
          label: (
            <span data-testid={CREATE_KEY_METHOD_OPTION_TEST_ID('pkcs')}>
              {CREATE_KEY_METHOD_PKCS_LABEL}
            </span>
          )
        },
        {
          value: 'jwt',
          label: (
            <span data-testid={CREATE_KEY_METHOD_OPTION_TEST_ID('jwt')}>
              {CREATE_KEY_METHOD_JWT_LABEL}
            </span>
          )
        }
      ]}
    />
    <div
      data-testid={CREATE_KEY_METHOD_INFO_TEST_ID}
      className="flex items-start gap-2.5 rounded-md bg-highlight-surface px-4 py-[9px]"
    >
      <InformationCircleIcon className="size-5 shrink-0 text-content-primary" />
      <p className="text-sm leading-[18px] text-content-primary">
        {infoMessage(value, requiresUpload)}
      </p>
    </div>
  </div>
);
